export default __webpack_public_path__ + "static/RED_GLOW_BG-c0e2d9c20198d95d59f57fdbf2870c49.png";